import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inmaterial',
  templateUrl: './inmaterial.component.html',
  styleUrls: ['./inmaterial.component.css']
})
export class InmaterialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  public onMapReady(event) {
    console.log("Map Ready")
  }

}
